import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppPage } from 'view/components/common/AppPage';
import PanelButton from 'view/components/common/PanelButton';

const StaffHome: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AppPage>
      <div className="app-main-content">
        <h1>Staff Home</h1>
        <div className="classroom-list">
          <PanelButton
            label="Catalog"
            onClick={() => navigate('/staff/catalog')}
          />
        </div>
      </div>
    </AppPage>
  );
};

export default StaffHome;
